import { render, staticRenderFns } from "./customFields.vue?vue&type=template&id=c43d4c5c"
import script from "./customFields.vue?vue&type=script&lang=js"
export * from "./customFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports